import type { CSSProperties } from 'react';
import { FONT } from './constants';

export const C = {
  ink: '#0E1A1A',
  brand: '#15A08C',
  brandDark: '#0F6E56',
  brandBg: '#E1F5EE',
  brandDarkText: '#04342C',
  muted: '#1A2332',
  faint: '#6B7280',
  line: '#E5E7EB',
  page: '#F8F9FA',
  cream: '#F1EFE8',
  creamBorder: '#D3D1C7',
  danger: '#A32D2D',
  amber: '#854F0B',
  amberBg: '#FAEEDA',
  amberText: '#633806',
} as const;

export const displayBox: CSSProperties = {
  display: 'inline-block',
  boxSizing: 'border-box',
  padding: '6px 10px',
  border: '1px solid ' + C.line,
  borderRadius: 6,
  fontSize: 13,
  textAlign: 'right',
  color: C.faint,
  background: C.page,
  fontFamily: FONT,
  fontVariantNumeric: 'tabular-nums',
};

export const inputBox: CSSProperties = {
  boxSizing: 'border-box',
  padding: '6px 10px',
  border: '1px solid ' + C.line,
  borderRadius: 6,
  fontSize: 13,
  textAlign: 'right',
  color: C.ink,
  fontFamily: FONT,
};